module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container mt-5 mb-5"
  }, [(_vm.passwordChanged === false) ? _c('div', {
    staticClass: "set-password__container mt-5 mb-5"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('SET_PASSWORD')))]), _vm._v(" "), _c('p', {
    staticClass: "set-password__heading"
  }, [_vm._v(_vm._s(_vm.$t('SET_PASSWORD_TO_ACCOUNT')))]), _vm._v(" "), _c('p', {
    staticClass: "set-password__heading"
  }, [_vm._v(_vm._s(_vm.$t('SAVE_PASSWORD_SHOULD')))]), _vm._v(" "), _c('form', {
    staticClass: "form--main mt-5 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "control"
  }, [(_vm.errors.has('password') || _vm.errors.has('repeatPassword')) ? _c('p', {
    staticClass: "validate-danger"
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/images/icons/excl-red.svg")
    }
  }), _vm._v("\n                        " + _vm._s(_vm.$t('COMPLETE_FIELDS_CORRECTLY')) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.passwordRegex
      }),
      expression: "{ required: true, regex: passwordRegex }"
    }],
    staticClass: "text-input -white-input-border",
    class: {
      validate: _vm.errors.has('password')
    },
    attrs: {
      "id": "password",
      "data-vv-validate-on": "none",
      "name": "password",
      "placeholder": _vm.$t('PASSWORD'),
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatPassword),
      expression: "repeatPassword"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: _vm.passwordRegex,
        confirmed: _vm.password
      }),
      expression: "{ required: true, regex: passwordRegex, confirmed: password }"
    }],
    staticClass: "text-input -white-input-border",
    class: {
      validate: _vm.errors.has('repeatPassword')
    },
    attrs: {
      "id": "repeatPassword",
      "data-vv-validate-on": "none",
      "name": "repeatPassword",
      "placeholder": _vm.$t('PASSWORD_CONFIRM'),
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.remindPassword.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('SEND_WITHOUT_DOT')) + "\n            ")])])]) : _c('div', {
    staticClass: "text-xs-center mt-5 mb-5"
  }, [_c('p', {
    staticClass: "forgot-password-sent"
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/images/icons/check-red.svg")
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('PASSWORD_CORRECTLY_CHANGED')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('GO_BACK_TO_LOGIN_PAGE')) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0acd9738","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/auth/password-reminder-finish.vue
// module id = 1157
// module chunks = 0